import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfoboxService } from 'src/app/services/infobox.service';
import { MediaService } from 'src/app/services/media.service';
import { PageService } from 'src/app/services/page.service';
import { SpecialisatieService } from 'src/app/services/specialisatie.service';

@Component({
  selector: 'app-specialisatie',
  templateUrl: './specialisatie.component.html',
  styleUrls: ['./specialisatie.component.sass']
})
export class SpecialisatieComponent implements OnInit {

  specId:any;
  spec:any = {};
  infoboxes:any = [];

  constructor(private activatedRoute: ActivatedRoute,
    private specService:SpecialisatieService,
    private pageService:PageService,
    private infoboxService:InfoboxService) { }

  ngOnInit(): void {
    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;

    if(!params) return;

    this.specId = params["specid"];

    this.specService.getSpecialisatie(this.specId).subscribe(data => {
      this.spec = this.specService.populateSpecialisatie(data.data[0]);
      this.pageService.setCurrentHeader(this.spec.banner_image);
    });

    this.infoboxService.getBoxesFor(this.specId).subscribe(data => {
      data.data.forEach((element:any) => {
        this.infoboxes.push(this.infoboxService.populateBox(element));
      });
    });
  }

}
